var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            title: "Sửa đại lý",
            visible: _vm.isOpenUpdateBrandDialog,
            width: "550px",
            "panel-icon": "el-icon-edit-outline",
            "panel-title": "CHỈNH SỬA THÔNG TIN ĐẠI LÝ",
            "panel-subtitle":
              "Cập nhật tên, trạng thái và thiết lập hạn mức số học sinh tối đa được sử dụng dịch vụ thanh toán.",
            "confirm-loading": _vm.loading.submit,
            "confirm-text": "Cập nhật",
            "cancel-text": "Hủy bỏ",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenUpdateBrandDialog = $event
            },
            "before-close": _vm.handleClose,
            cancel: _vm.handleClose,
            confirm: _vm.submitForm,
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "modern-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Tên đầy đủ đại lý", prop: "full_name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Nhập tên đầy đủ...",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.full_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "full_name", $$v)
                      },
                      expression: "formData.full_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Tên viết tắt (mã nhận diện)",
                    prop: "short_name",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Nhập tên viết tắt...",
                      maxlength: "20",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.formData.short_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "short_name", $$v)
                      },
                      expression: "formData.short_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái hoạt động", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: { placeholder: "Chọn trạng thái" },
                      model: {
                        value: _vm.formData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "status", $$v)
                        },
                        expression: "formData.status",
                      },
                    },
                    _vm._l(_vm.statusBrand, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Học sinh tối đa",
                            prop: "numberOnlinePayments",
                          },
                        },
                        [
                          _c("el-input-number", {
                            staticClass: "full-width-number",
                            attrs: { min: 0 },
                            model: {
                              value: _vm.formData.numberOnlinePayments,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "numberOnlinePayments",
                                  $$v
                                )
                              },
                              expression: "formData.numberOnlinePayments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "pt-item",
                          attrs: {
                            label: "Cấu hình hạn mức",
                            prop: "onlinePaymentLimit",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticClass: "modern-checkbox",
                              model: {
                                value: _vm.formData.onlinePaymentLimit,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "onlinePaymentLimit",
                                    $$v
                                  )
                                },
                                expression: "formData.onlinePaymentLimit",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Giới hạn học sinh\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }